import packageJson from "../../package.json";

// eslint-disable-next-line no-underscore-dangle
export default () => [packageJson.version, packageJson._lastCommit];
